import axios from 'axios';
import { SuggestionOutput, SuggestionQuery } from '../../types/Suggestion';

class SuggestionsService {
  async getSuggestions(query: SuggestionQuery): Promise<SuggestionOutput[]> {
    const result = await axios.get('/suggestions', { params: query });
    return result.data;
  }

  async postSuggestions(query: SuggestionQuery): Promise<SuggestionOutput[]> {
    const result = await axios.post('/suggestions', query);
    return result.data;
  }
}

const suggestionsService = new SuggestionsService();
export default suggestionsService;
